<template>
  <div class="points-content">
    <van-list v-model="loading" :finished="finished" finished-text="" :error.sync="error" error-text="请求失败，点击重新加载" @load="getList">
      <div class="title">
        <div class="line"></div>
        <span>积分获取记录</span>
      </div>
      <div class="list-wrap">
        <div class="item" v-for="(item, index) in listData" :key="index">
          <div class="action">{{ item.eventNote }}</div>
          <div class="info">
            <div class="count">
              {{ item.type == 1 ? '+' : '-' }}
              {{ item.nums }}
            </div>
            <div class="date">{{ parseTime(item.createdAt, '{y}-{m}-{d}') }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getList } from '@/service/system/points'
import { parseTime } from '@/utils/tools.js'
export default {
  name: 'Points',
  data() {
    return {
      listData: [],
      loading: false,
      finished: false,
      error: false,
      meta: {
        page: 1,
        pagesize: 10
      }
    }
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const { data } = await getList(this.meta)
        if (data.pageCount <= this.meta.page) {
          this.finished = true
        } else {
          this.meta.page += 1
        }
        this.listData = [...this.listData, ...data.list]
        this.loading = false
      } catch (error) {
        this.loading = false
        this.finished = false
        this.error = true
      }
    },
    parseTime
  }
}
</script>

<style lang="stylus" scoped>
.points-content
  height: 100%
  overflow-y: auto
.title
  display: flex
  align-items: center
  padding: 18px 30px
  background: #F7F9F9
  .line
    width: 10px
    height: 28px
    margin-right: 20px
    background: #2D8DFF
  span
    font-size: 32px
    line-height: 45px
    font-weight: 500
.list-wrap
  padding: 0 30px
  .item
    height: 120px
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 1px solid #EEEEEE
    .action
      font-size: 30px
      color: #333333
    .info
      text-align: right
      .count
        margin-top: 20px
        font-size: 30px
        line-height: 40px
        color: #333333
      .date
        font-size: 22px
        line-height: 40px
        color: #999999
</style>
